// extracted by mini-css-extract-plugin
export default {"imgList":"style_imgList__I9aTX","imgBox":"style_imgBox__u4Dan","img":"style_img__dj6ri","removeImgBtn":"style_removeImgBtn__4ZSiL"};